module.exports = __webpack_public_path__ + "static/media/presentation-xl.584ae3b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headers/presentation-xl.jpg
// module id = 403
// module chunks = 12